import { Component, OnInit, Input, ElementRef, ComponentRef } from '@angular/core'
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { Arquivo } from '../../../_classes/arquivo';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';

@Component({
  selector: 'app-contrato-info',
  templateUrl: './contrato-info.component.html',
  styleUrls: ['./contrato-info.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pt-BR' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS }
  ]
})
export class ContratoInfoComponent implements OnInit {

  contrato: Arquivo
  selfReference: ComponentRef<ContratoInfoComponent>
  exibir: boolean

  mascaraCnpj = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/,]
  mascaraContrato = [/\d/, /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]
  mascaraDinheiro = createNumberMask({
    prefix: 'R$ ',
    thousandsSeparatorSymbol: '.',
    decimalSymbol: ',',
    decimalLimit: 2,
    allowDecimal: true,
    suffix: ''
  })

  constructor() {
  }

  ngOnInit() {
    this.contrato.identificador = this.contrato.identificador || ''
    this.contrato.numeroContrato = this.contrato.numeroContrato || ''
    this.contrato.primeiroAditivo = this.contrato.primeiroAditivo || ''
    this.contrato.segundoAditivo = this.contrato.segundoAditivo || ''
    this.contrato.valorContrato = this.contrato.valorContrato || ''
  }

  alterarVisibilidade() {
    this.exibir = !this.exibir
  }

  destruir() {
    this.selfReference.destroy();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/contrato/contrato-info/contrato-info.component.ts